(function () {
  function init() {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const entries = [];
    document.querySelectorAll('[data-motion-video]').forEach(video => {
      if (video.dataset.mobileSrc && matchMedia('(max-width: 700px)').matches) {
        video.dataset.src = video.dataset.mobileSrc;
        video.poster = video.dataset.mobilePoster;
      }
      const button = document.querySelector('[data-motion-toggle="' + video.id + '"]');
      if (!button) return;
      const state = {video, button, visible: false, requested: video.hasAttribute('data-autoplay') && !reduced.matches && !navigator.connection?.saveData};
      entries.push(state);
      button.hidden = false;
      const hero = video.id === 'freya-hero-video';
      function updateButton() {
        const playing = !video.paused;
        button.setAttribute('aria-pressed', String(playing));
        button.setAttribute('aria-label', (hero ? 'Açılış animasyonunu ' : 'Kısa filmi ') + (playing ? 'duraklat' : 'oynat'));
        button.innerHTML = (playing ? 'Duraklat' : (hero ? 'Oynat' : 'Kısa filmi oynat')) + '<span aria-hidden="true">' + (playing ? 'Ⅱ' : '▷') + '</span>';
      }
      state.sync = function () {
        if (!state.requested || !state.visible || document.hidden) {video.pause();return;}
        if (!video.hasAttribute('src')) video.src = video.dataset.src;
        video.muted = true;
        video.play().catch(() => {state.requested = false;updateButton();});
      };
      video.addEventListener('play', () => {video.dataset.hasPlayed = '';updateButton();});
      video.addEventListener('pause', updateButton);
      video.addEventListener('error', () => {state.requested = false;video.removeAttribute('data-has-played');button.textContent = 'Video yüklenemedi';button.disabled = true;});
      button.addEventListener('click', () => {state.requested = video.paused;state.sync();});
      const observer = new IntersectionObserver(records => {
        state.visible = records[0].isIntersecting;
        state.sync();
      }, {threshold: .1});
      observer.observe(video);
      updateButton();
    });
    document.addEventListener('visibilitychange', () => entries.forEach(entry => entry.sync()));
    reduced.addEventListener('change', () => {if (reduced.matches) entries.forEach(entry => {entry.requested = false;entry.sync();});});
    document.querySelectorAll('.log-film-full').forEach(details => {
      const video = details.querySelector('[data-full-film]');
      details.addEventListener('toggle', () => {
        if (details.open) {
          entries.forEach(entry => {entry.requested = false;entry.sync();});
          if (!video.hasAttribute('src')) video.src = video.dataset.src;
        } else video.pause();
      });
    });
    const partner = document.querySelector('[data-collaborations]');
    if (partner) {
      const query = new URLSearchParams(location.search);
      const partnerIndex = {'the-log': '1', 'dante': '0', 'hand-made': '4'}[query.get('partner')];
      const partnerButton = partnerIndex !== undefined && partner.querySelector('[data-partner-index="' + partnerIndex + '"]');
      const openRequestedPartner = () => {
        if (partnerButton && partnerButton.getAttribute('aria-expanded') !== 'true') partnerButton.click();
      };
      if (partner.hasAttribute('data-ready')) queueMicrotask(openRequestedPartner);
      else {
        const ready = new MutationObserver(() => {
          if (partner.hasAttribute('data-ready')) { ready.disconnect(); queueMicrotask(openRequestedPartner); }
        });
        ready.observe(partner, {attributes: true, attributeFilter: ['data-ready']});
      }
      const content = partner.querySelector('.freya-collab-content');
      new MutationObserver(() => {
        partner.querySelectorAll('video').forEach(video => {
          if (video.closest('[hidden]')) {
            video.pause();
            const entry = entries.find(entry => entry.video === video);
            if (entry) entry.requested = false;
          }
        });
      }).observe(content, {attributes:true, subtree:true, attributeFilter:['hidden']});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
